import { tributes } from '../../mock/tributes.json'

const state = {
  tributes,
}

const getters = {
  getPostsTributes: state => postId =>
    state.tributes
      .filter(t => t.postId === postId)
      .reduce((userIds, t) => userIds.concat([t.userId]), []),
}

const mutations = {
  toggleTribute(state, { postId, userId }) {
    let index = state.tributes.indexOf(
      t => t.postId === postId && t.userId === userId,
    )
    if (index >= 0) {
      state.tributes.splice(index, 1)
    } else {
      state.tributes.push({ postId, userId })
    }
    console.debug('vuex.toggleTribute', {
      userId,
      postId,
      status: index >= 0 ? 'removed' : 'added',
    })
  },
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions,
}
